<template>
    <div v-if="recordSelected.user.name">
        <div class="modal fade" id="viewRecord" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> <strong>Xem chi tiết Hóa đơn</strong> </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="text-danger"><i
                                    class="fa-regular fa-circle-xmark"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p><label for="exampleInputEmail1"><strong>Tên Học viên</strong></label> : {{
                            recordSelected.user.name }}</p>
                        <p><label for="exampleInputEmail1"><strong>Email Học viên</strong></label> : {{
                            recordSelected.user.email }}</p>
                        <p><label for="exampleInputEmail1"><strong>Ghi chú</strong></label> : 
                        {{ recordSelected.note }}</p>
                        <div class="mb-2 mt-2 infor-revenue">
                            <span><i class="fa-solid fa-coins"></i> Doanh thu thực: <span class="text-primary">{{
                                this.$formatNumber(recordSelected.revenue) }} VNĐ</span> </span>
                            <span class="ml-3"><i class="fa-solid fa-coins"></i> VAT: <span class="text-danger">{{
                                this.$formatNumber(recordSelected.vat_percentage) }} (%)</span></span>
                            <span class="ml-3"><i class="fa-solid fa-coins"></i> VAT: <span class="text-danger">{{
                                this.$formatNumber(recordSelected.vat_amount) }} VNĐ</span></span>
                            <span class="ml-3"><i class="fa-solid fa-coins"></i> Lợi nhuận: <span
                                    class="text-success">{{ this.$formatNumber(recordSelected.profit) }}
                                    VNĐ</span></span>
                        </div>
                        <div><strong>Danh sách khóa học trong hóa đơn này</strong></div>
                        <div class="pl-3 container-list-course">
                            <li class="list-name-course" v-for="(name_course, index) in recordSelected.name_courses"
                                :key="index">{{ name_course }}</li>
                        </div>
                    </div>
                    <br>
                    <div class="modal-footer mt-1">
                        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" ref="closeButton"
                            id="close">Đóng</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "ViewRecord",

    props: {
        recordSelected: Object
    },

    data() {
        return {

        }
    },

    methods: {

    }

}
</script>

<style scoped>
.modal-header .close {
    outline: none;
}

.modal-dialog {
    max-width: 1000px;
}

.container-list-course {
    max-height: 45vh;
    overflow: hidden;
    overflow-y: scroll;
}

.list-name-course {
    list-style: auto;
}

@media screen and (min-width: 1201px) {}

@media screen and (max-width: 1200px) {
    .modal-dialog {
        max-width: 400px;
        margin: 10px auto;
        font-size: 13px;
        ;
    }

    .modal-header {
        padding: auto;
    }

    .modal-header .close {
        font-size: 20px;
    }

    .btn {
        font-size: 13px;
    }
}

@media screen and (max-width: 992px) {
    .modal-dialog {
        max-width: 350px;
        margin: 10px auto;
        font-size: 11px;
        ;
    }

    .modal-header {
        padding: auto;
    }

    .modal-header .close {
        font-size: 18px;
    }

    .btn {
        font-size: 12px;
    }

    .modal-body {
        padding: 14px 14px 0 14px;
    }
}

@media screen and (max-width: 768px) {
    .modal-dialog {
        max-width: 320px;
        margin: 10px auto;
        font-size: 9px;
        ;
    }

    .modal-header {
        padding: auto;
    }

    .modal-header .close {
        font-size: 11px;
    }

    .btn {
        font-size: 10px;
    }

    .modal-body {
        padding: 14px 14px 0 14px;
    }

    .alert {
        padding: 8px;
    }
}

@media screen and (min-width: 425px) and (max-width: 575px) {
    .modal-dialog {
        max-width: 275px;
        margin: 10px auto;
        font-size: 9px;
        ;
    }

    .modal-header,
    .modal-footer {
        padding: 5px 5px;
    }

    .modal-header .close {
        font-size: 11px;
    }

    .btn {
        font-size: 8px;
    }

    .modal-body {
        padding: 12px 12px 0 12px;
    }

    .alert {
        padding: 8px;
    }
}

@media screen and (max-width: 424px) {
    .modal-dialog {
        max-width: 180px;
        margin: 10px auto;
        font-size: 7px;
        ;
    }

    .modal-header,
    .modal-footer {
        padding: 5px 5px;
    }

    .modal-header .close {
        font-size: 9px;
    }

    .btn {
        font-size: 7px;
    }

    .modal-body {
        padding: 11px 11px 0 11px;
    }

    .alert {
        padding: 6px 10px;
    }
}
</style>